@for (entry of deviceEntries(); track entry.id) {
  <div class="device-row">
    @if (entry.data) {
      <div class="device-name">
        <a
          class="avs-truncate text-sm font-medium hover:underline"
          [routerLink]="['/devices', entry.data.location.id, entry.data.id]"
        >
          {{ entry.data.friendlyName }}
        </a>
        <avs-li-space-location [config]="entry.spaceConfig!" />
      </div>
      <div class="device-details">
        <avs-device-connection-status-widget
          class="flex-shrink-0"
          [device]="entry.data"
        />
        <avs-device-status-badge
          class="flex-shrink-0"
          [device]="entry.data"
        />
      </div>
    } @else {
      <ngx-skeleton-loader
        [theme]="{ height: '20px', width: '100%' }"
        appearance="line"
      />
    }
  </div>
} @empty {
  <span class="text-ui-gray-100 text-sm m-auto">No devices configured</span>
}
